import { Box, TextField, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { IHeader } from 'components/Header';
import Header from 'components/Header/Header';
import { useNavigate } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { IReducer } from 'Reducers/IReducer';
import { AuditTable } from './AuthTable';
import { IAudit } from './IAudit';
import { useEffect, useState, useCallback } from 'react';
import { getAuditLogs } from 'actions/LaboratoryActions';

const ACTION_OPTIONS = [
  { value: '', label: 'All Actions' },
  { value: 'SAMPLE_CREATED', label: 'Sample Created' },
  { value: 'SAMPLE_UPDATED', label: 'Sample Updated' },
  { value: 'RESULT_ADDED', label: 'Result Added' },
  { value: 'RESULT_APPROVED', label: 'Result Approved' },
  { value: 'RESULT_REJECTED', label: 'Result Rejected' },
  { value: 'ULR_GENERATED', label: 'ULR Generated' },
  { value: 'PARAMETER_ASSIGNED', label: 'Parameter Assigned' },
];

export function _Audit(props: IAudit) {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [actionFilter, setActionFilter] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [page, setPage] = useState(1);
  const pageSize = 20;

  const fetchLogs = useCallback(() => {
    const laboratoryId = props.laboratory?.details?._id || '';
    if (!laboratoryId) return;

    const params: any = { page, size: pageSize };
    if (searchQuery) params.sampleId = searchQuery;
    if (actionFilter) params.action = actionFilter;
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    props.getAuditLogs(laboratoryId, params);
  }, [props.laboratory, searchQuery, actionFilter, startDate, endDate, page]);

  useEffect(() => {
    setPage(1);
  }, [searchQuery, actionFilter, startDate, endDate]);

  useEffect(() => {
    fetchLogs();
    // eslint-disable-next-line
  }, [page, searchQuery, actionFilter, startDate, endDate]);

  const breadcrumbsList: IHeader['breadcrumbsList'] = [
    {
      label: 'Dashboard',
      onClick: () => navigate('/'),
    },
    {
      label: 'Audit Log',
      onClick: () => navigate('/laboratory/audits'),
    },
  ];

  return (
    <Box>
      <Header breadcrumbsList={breadcrumbsList} title="Audit Log" />
      <Box p={2} pt={10}>
        <Box display="flex" gap={2} mb={2} flexWrap="wrap" alignItems="center">
          <TextField
            label="Search by Sample ID"
            size="small"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            sx={{ minWidth: 200 }}
          />
          <FormControl size="small" sx={{ minWidth: 180 }}>
            <InputLabel>Action</InputLabel>
            <Select
              value={actionFilter}
              label="Action"
              onChange={(e) => setActionFilter(e.target.value)}
            >
              {ACTION_OPTIONS.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Start Date"
            type="date"
            size="small"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{ minWidth: 160 }}
          />
          <TextField
            label="End Date"
            type="date"
            size="small"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{ minWidth: 160 }}
          />
        </Box>
        <AuditTable data={props.auditLogs || []} />
        {props.auditCount > 1 && (
          <Box display="flex" justifyContent="center" mt={2} gap={1}>
            <button disabled={page <= 1} onClick={() => setPage(page - 1)}>
              Previous
            </button>
            <span>
              Page {page} of {props.auditCount}
            </span>
            <button disabled={page >= props.auditCount} onClick={() => setPage(page + 1)}>
              Next
            </button>
          </Box>
        )}
      </Box>
    </Box>
  );
}

const mapStateToProps = (state: IReducer) => ({
  laboratory: state.laboratory.current,
  auditLogs: state.laboratory.audit,
  auditCount: state.laboratory.auditCount,
});

function mapDispatchToProps(dispatch: any) {
  return {
    ...bindActionCreators({ getAuditLogs }, dispatch),
  };
}

export const Audit = connect(mapStateToProps, mapDispatchToProps)(_Audit);
